import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Philosophy from "@/components/sections/Philosophy";
import Pillars from "@/components/sections/Pillars";
import Framework from "@/components/sections/Framework";
import MeetBen from "@/components/sections/MeetBen";
import Coaching from "@/components/sections/Coaching";
import ProgramDownload from "@/components/sections/ProgramDownload";
import Testimonial from "@/components/sections/Testimonial";
import FAQ from "@/components/sections/FAQ";
import ContactSection from "@/components/sections/ContactSection";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen" style={{ backgroundColor: "#F7F5F0" }}>
      <Navbar />
      <main>
        <Hero />
        <Philosophy />
        <Pillars />
        <Framework />
        <MeetBen />
        <Coaching />
        <ProgramDownload />
        <Testimonial />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
